import React from "react";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Loadable from "react-loadable";
import Loader from "../components/loader";

/**
 * Constants for page title and description
 */
export const siteTitle = "Taxida";
export const siteMetaDescription =
  "Taxida offers a hassle-free, reliable and affordable taxi cab service to travel within city or outstation across India.";

/**
 * Function is to set Title for each page
 * @param {*} title
 */
export const setTitle = (title) => {
  document.title = title ? title : siteTitle;
};

/**
 * Function is to set page description
 * @param {*} description
 */
export const setMetaDescription = (description) => {
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", description ? description : siteMetaDescription);
};

/**
 * List of routes for the page
 */
export const ROUTE = {
  public: [
    {
      exact: true,
      path: "/",
      meta: {},
      name: "Home", // for breadcrumbs
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/login",
      meta: {},
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/forgot-password",
      meta: {},
      component: Loadable({
        loader: () => import("../containers/login/ForgotPassword"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/create-password",
      meta: {},
      component: Loadable({
        loader: () => import("../containers/login/CreatePassword"),
        loading: Loader,
      }),
    },
  ],
  private: [
    {
      exact: true,
      path: "/dashboard",
      meta: {},
      name: "Dashboard",
      component: Loadable({
        loader: () => import("../containers/dashboard"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/analytics-dashboard-v2",
      meta: {},
      name: "Analytics Dashboard V2",
      component: Loadable({
        loader: () => import("../containers/analyticsDashboardV2"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/bookings/add",
      meta: {},
      name: "Add booking",
      component: Loadable({
        loader: () => import("../containers/bookings"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/bookings/add/:id",
      meta: {},
      name: "Add booking",
      component: Loadable({
        loader: () => import("../containers/bookings"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/bookings/addnew",
      meta: {},
      name: "Add booking New",
      component: Loadable({
        loader: () => import("../containers/bookingsNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/bookings/addnew/:id",
      meta: {},
      name: "Add booking New",
      component: Loadable({
        loader: () => import("../containers/bookingsNew"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/b2bbookings/add",
    //   meta: {},
    //   name: "B2B booking",
    //   component: Loadable({
    //     loader: () => import("../containers/bookings/B2BBooking"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/b2bbookings/add/:id",
      meta: {},
      name: "B2B booking",
      component: Loadable({
        loader: () => import("../containers/tripList/B2BTriplist/B2BDetails"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/b2benquiry/:id",
      meta: {},
      name: "B2B booking enquiry",
      component: Loadable({
        loader: () =>
          import("../containers/tripList/B2BTriplist/EnquiryDetails"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/seller-enquiry/:id/:messageId",
      meta: {},
      name: "B2B booking enquiry",
      component: Loadable({
        loader: () =>
          import("../containers/tripList/B2BTriplist/EnquiryDetailsSeller.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/taxida-enquiry/:id",
      meta: {},
      name: "B2B booking enquiry",
      component: Loadable({
        loader: () =>
          import("../containers/tripList/B2BTriplist/EnquiryDetailsTaxida.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/etsbookings/add",
      meta: {},
      name: "ETS booking",
      component: Loadable({
        loader: () => import("../containers/ets/index"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/etsbookings/details/:id",
      meta: {},
      name: "ETS booking",
      component: Loadable({
        loader: () => import("../containers/EtsDetailView/ETSDetails"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/etsbookings/pop",
    //   meta: {},
    //   name: "ETS booking",
    //   component: Loadable({
    //     loader: () => import("../containers/ets/EtsEmployeePopup.jsx"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/branch-manager/add",
      meta: {},
      name: "Shuttle booking",
      component: Loadable({
        loader: () => import("../containers/shuttleBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aucto-bookings/update/:id",
      meta: {},
      name: "Aucto booking",
      component: Loadable({
        loader: () => import("../containers/bookings/AuctoBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/trips",
      meta: {},
      name: "Trip list",
      component: Loadable({
        loader: () => import("../containers/tripList"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/taxida-trips/:id",
      meta: {},
      name: "Taxida Trips  ",
      component: Loadable({
        loader: () =>
          import("../containers/tripList/B2BTriplist/OndcDetails.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/b2btrips",
      meta: {},
      name: "B2B TRIP list",
      component: Loadable({
        loader: () => import("../containers/tripList/B2BTriplist"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/all-trips",
      meta: {},
      name: "TRIP list",
      component: Loadable({
        loader: () => import("../containers/tripList/TripListNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/etstrips",
      meta: {},
      name: "ETS TRIP list",
      component: Loadable({
        loader: () => import("../containers/tripList/EtsTriplist"),
        loading: Loader,
      }),
    },
     {
      exact: true,
      path: "/savaari",
      meta: {},
      name: "Savaari Trip List",
      component: Loadable({
        loader: () => import("../containers/tripList/SavaariAudits/SavaariTabs"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/broadcast-fulfilment",
      meta: {},
      name: "Broadcast fulfilment",
      component: Loadable({
        loader: () => import("../containers/broadcastFulfilment"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/demand-partners",
      meta: {},
      name: "API Partners transactions",
      component: Loadable({
        loader: () => import("../containers/demandPartners"),
        loading: Loader,
      }),
    },
    {
  exact: true,
  path: "/savaari-details/:bookingId",
  meta: {},
  name: "Savaari Details",
  component: Loadable({
    loader: () => import("../containers/tripList/SavaariAudits/SavaariDetails"),
    loading: Loader,
  }),
},
{
  exact: true,
  path: "/partner-audit-details/:conf",
  meta: {},
  name: "Partner Booking Audit",
  component: Loadable({
    loader: () => import("../containers/demandPartners/PartnerAuditDetail"),
    loading: Loader,
  }),
},
{
  exact: true,
  path: "/search-inspection/:searchId",
  meta: {},
  name: "Search Inspection",
  component: Loadable({
    loader: () => import("../containers/demandPartners/SearchInspection"),
    loading: Loader,
  }),
},
    {
      exact: true,
      path: "/bid-list",
      meta: {},
      name: "Bid list",
      component: Loadable({
        loader: () => import("../containers/bidList"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/accepted-trips",
      meta: {},
      name: "Accepted trips",
      component: Loadable({
        loader: () => import("../containers/acceptedTrips"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/distance",
      meta: {},
      name: "Distance fare",
      component: Loadable({
        loader: () => import("../containers/fares/Distance"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/geofence",
      meta: {},
      name: "Geofence fare",
      component: Loadable({
        loader: () => import("../containers/fares/Geofence"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/fares/hot-routes",
      meta: {},
      name: "Hotroutes list",
      component: Loadable({
        loader: () => import("../containers/fares/Hotroutes"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/hot-routes/geofence",
      meta: {},
      name: "Hotroutes Geofence",
      component: Loadable({
        loader: () =>
          import("../containers/fares/Hotroutes/HotRoutesGeofence.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/hot-routes/geofence/:hotRouteId",
      meta: {},
      name: "Hotroutes Geofence",
      component: Loadable({
        loader: () =>
          import("../containers/fares/Hotroutes/HotRoutesGeofence.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/fares/operate-area",
      meta: {},
      name: "Operating area list",
      component: Loadable({
        loader: () => import("../containers/fares/OperatingAreaNew"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/fares/operate-area/geofence",
      meta: {},
      name: "Operating area Geofence",
      component: Loadable({
        loader: () =>
          import("../containers/fares/OperatingAreaNew/OperatingAreaGeofence.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/operate-area/geofence/:hotRouteId",
      meta: {},
      name: "Operating area Geofence",
      component: Loadable({
        loader: () =>
          import("../containers/fares/OperatingAreaNew/OperatingAreaGeofence.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/calender",
      meta: {},
      name: "Calendar fare",
      component: Loadable({
        loader: () => import("../containers/fares/Calender"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/time",
      meta: {},
      name: "Time fare",
      component: Loadable({
        loader: () => import("../containers/fares/Time"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/fixed-fare",
      meta: {},
      name: "Fixed fare",
      component: Loadable({
        loader: () => import("../containers/fares/FixedFare"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/route-based-fare",
      meta: {},
      name: "Route based fare",
      component: Loadable({
        loader: () => import("../containers/fares/RouteBasedFare"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/locations",
      meta: {},
      name: "Locations",
      component: Loadable({
        loader: () => import("../containers/location"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/fares/operating-area",
      meta: {},
      name: "Operating area",
      component: Loadable({
        loader: () => import("../containers/fares/OperatingArea"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/commissions",
      meta: {},
      name: "Pricing control",
      component: Loadable({
        loader: () => import("../containers/commissions"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/driver",
      meta: {},
      name: "Driver",
      component: Loadable({
        loader: () => import("../containers/drivers/Driver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/driver/addDriver",
      meta: {},
      name: "Add driver",
      component: Loadable({
        loader: () => import("../containers/addDriver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/driver/addDriver/:driverId",
      meta: {},
      name: "Add driver",
      component: Loadable({
        loader: () => import("../containers/addDriver"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/users/drivers/corporate-driver",
      meta: {},
      name: "Corporate Driver",
      component: Loadable({
        loader: () => import("../containers/drivers/CorporateDriver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/corporate-driver/add",
      meta: {},
      name: "Add Corporate driver",
      component: Loadable({
        loader: () => import("../containers/addDriver/AddCorporateDriver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/corporate-driver/add/:corporateDriverId",
      meta: {},
      name: "Add Corporate driver",
      component: Loadable({
        loader: () => import("../containers/addDriver/AddCorporateDriver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/groups",
      meta: {},
      name: "Driver group",
      component: Loadable({
        loader: () => import("../containers/drivers/DriverGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/groups/add",
      meta: {},
      name: "Drivers list",
      component: Loadable({
        loader: () =>
          import("../containers/drivers/DriverGroup/AddDriverGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/drivers/groups/add/:groupId",
      meta: {},
      name: "Drivers list",
      component: Loadable({
        loader: () =>
          import("../containers/drivers/DriverGroup/AddDriverGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/operator",
      meta: {},
      name: "Operator",
      component: Loadable({
        loader: () => import("../containers/users/Operators/Operator"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/operator/addOperator",
      meta: {},
      name: "Add Operator",
      component: Loadable({
        loader: () => import("../containers/addOperator"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/operator/addOperator/:operatorId",
      meta: {},
      name: "Add Operator",
      component: Loadable({
        loader: () => import("../containers/addOperator"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/new-temp",
      meta: {},
      name: "Temp list",
      component: Loadable({
        loader: () =>
          import("../containers/bookings/modals/DriverDetails/newTemp"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/groups",
      meta: {},
      name: "Operator group",
      component: Loadable({
        loader: () => import("../containers/users/Operators/OperatorGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/groups/add",
      meta: {},
      name: "Operators list",
      component: Loadable({
        loader: () =>
          import("../containers/users/Operators/OperatorGroup/AddOperatorGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/operators/groups/add/:groupId",
      meta: {},
      name: "Operators list",
      component: Loadable({
        loader: () =>
          import("../containers/users/Operators/OperatorGroup/AddOperatorGroup"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/customers",
      meta: {},
      name: "Customers",
      component: Loadable({
        loader: () => import("../containers/users/Customers"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/vehicle",
      meta: {},
      name: "Vehicle",
      component: Loadable({
        loader: () => import("../containers/users/Vehicle"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/vehicle/add",
      meta: {},
      name: "Vehicle add",
      component: Loadable({
        loader: () => import("../containers/users/Vehicle/VehicleAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/vehicle/add/:id",
      meta: {},
      name: "Vehicle add",
      component: Loadable({
        loader: () => import("../containers/users/Vehicle/VehicleAdd"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/users/corporate-vehicle",
      meta: {},
      name: "Corporate Vehicle",
      component: Loadable({
        loader: () => import("../containers/users/Vehicle/CorporateVehicle"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/corporate-vehicle/add",
      meta: {},
      name: "Corporate Vehicle add",
      component: Loadable({
        loader: () =>
          import("../containers/users/Vehicle/VehicleAdd/CorporateVehicleAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/corporate-vehicle/add/:corporateVehicleId",
      meta: {},
      name: "Corporate Vehicle add",
      component: Loadable({
        loader: () =>
          import("../containers/users/Vehicle/VehicleAdd/CorporateVehicleAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/admins",
      meta: {},
      name: "Admin",
      component: Loadable({
        loader: () => import("../containers/users/Admin"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/controllers",
      meta: {},
      name: "Controller",
      component: Loadable({
        loader: () => import("../containers/users/Controller"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/business-user",
      meta: {},
      name: "Business user",
      component: Loadable({
        loader: () => import("../containers/users/BusinessUser"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/business-user/addBusinessUser",
      meta: {},
      name: "Business user",
      component: Loadable({
        loader: () => import("../containers/addBusinessUser"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/business-user/addBusinessUser/:businessUserId",
      meta: {},
      name: "Business user",
      component: Loadable({
        loader: () => import("../containers/addBusinessUser"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/vehicle-types",
      meta: {},
      name: "Vehicle types",
      component: Loadable({
        loader: () => import("../containers/vehicle-types"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/taxida-quotes",
      meta: {},
      name: "Taxida Quote Management",
      component: Loadable({
        loader: () => import("../containers/taxida-quote"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/statements",
      meta: {},
      name: "Driver statement",
      component: Loadable({
        loader: () => import("../containers/statementAndInvoice/Statement"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/statements/savaari-analytics",
      meta: {},
      name: "Savaari Analytics",
      component: Loadable({
        loader: () => import("../containers/savaariAnalytics"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/statements/invoice",
      meta: {},
      name: "Driver invoice",
      component: Loadable({
        loader: () => import("../containers/statementAndInvoice/Invoice"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/statements/invoice/:id",
      meta: {},
      name: "Driver invoice",
      component: Loadable({
        loader: () => import("../containers/statementAndInvoice/Invoice"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/statements/generate-statment",
      meta: {},
      name: "Generate statment",
      component: Loadable({
        loader: () =>
          import("../containers/statementAndInvoice/GenerateStatement"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/driver-registration",
      meta: {},
      name: "Driver registration",
      component: Loadable({
        loader: () => import("../containers/driverRegistration/DriverDetails"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/driver-registration/update/:dvId",
      meta: {},
      name: "Update driver registration",
      component: Loadable({
        loader: () =>
          import("../containers/driverRegistration/UpdateDriverRegistration"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/driver-alerts",
      meta: {},
      name: "Driver alerts",
      component: Loadable({
        loader: () => import("../containers/driverAlerts"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/operator-discount/add",
      meta: {},
      name: "Operator discount",
      component: Loadable({
        loader: () =>
          import("../containers/operatorDiscount/operatorDiscountAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/operator-discount/add/:id",
      meta: {},
      name: "Operator discount",
      component: Loadable({
        loader: () =>
          import("../containers/operatorDiscount/operatorDiscountAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/operator-discount",
      meta: {},
      name: "Operator discount",
      component: Loadable({
        loader: () => import("../containers/operatorDiscount"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aucto-config",
      meta: {},
      name: "AUCTO config",
      component: Loadable({
        loader: () => import("../containers/aucto/AuctoConfig"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/promo-codes/add",
      meta: {},
      name: "Promo code add",
      component: Loadable({
        loader: () => import("../containers/promoCodes/promoCodeAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/promo-codes/add/:id",
      meta: {},
      name: "Promo code add",
      component: Loadable({
        loader: () => import("../containers/promoCodes/promoCodeAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/promo-codes",
      meta: {},
      name: "Promo codes",
      component: Loadable({
        loader: () => import("../containers/promoCodes"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/taxida-commission",
      meta: {},
      name: "Taxida commission",
      component: Loadable({
        loader: () => import("../containers/taxidaCommission"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/price-surge",
      meta: {},
      name: "Price Engine Surge",
      component: Loadable({
        loader: () => import("../containers/PriceEngineSurge"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/reports",
      meta: {},
      name: "reports",
      component: Loadable({
        loader: () => import("../containers/reports"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/site-settings",
      meta: {},
      name: "Site settings",
      component: Loadable({
        loader: () => import("../containers/siteSettings"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate/add",
      meta: {},
      name: "Corporate add",
      component: Loadable({
        loader: () => import("../containers/corporate/corporateAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate-new/add",
      meta: {},
      name: "Corporate add",
      component: Loadable({
        loader: () => import("../containers/addCorporate"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/tmc-new/add",
      meta: {},
      name: "Tmc add",
      component: Loadable({
        loader: () => import("../containers/addTmc"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/vendor-new/add",
      meta: {},
      name: "Vendor add",
      component: Loadable({
        loader: () => import("../containers/addVendor"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/vendor-new/add/:vendorTypeId/:vendorId/:userId",
      meta: {},
      name: "Vendor add",
      component: Loadable({
        loader: () => import("../containers/Vendor/index.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/operator-new/add",
      meta: {},
      name: "Operator add",
      component: Loadable({
        loader: () => import("../containers/addOperatorNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/operator-new/add/:userId",
      meta: {},
      name: "Operator add",
      component: Loadable({
        loader: () => import("../containers/OperatorTab"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aggregator-new/add",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/addAggregator"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/user-new/add",
      meta: {},
      name: "User add",
      component: Loadable({
        loader: () => import("../containers/addUser"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/pricings/ota-new/add",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/addAggregator/AddOta.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/provider-new/add",
      meta: {},
      name: "Provider add",
      component: Loadable({
        loader: () => import("../containers/addProvider"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/geofence/add",
      meta: {},
      name: "Geofence add",
      component: Loadable({
        loader: () => import("../containers/pricingsNew/index"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/branch-manager/add",
      meta: {},
      name: "Branch manager add",
      component: Loadable({
        loader: () =>
          import("../containers/addCorporate/BranchManager/AddBranchManager"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/branch-manager/add/:branchManagerId",
      meta: {},
      name: "Branch manager add",
      component: Loadable({
        loader: () => import("../containers/shuttleBooking"),

        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate-new/add/:corporateId",
      meta: {},
      name: "Corporate add",
      component: Loadable({
        loader: () => import("../containers/addCorporate"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/tmc-new/add/:corporateId",
      meta: {},
      name: "Tmc add",
      component: Loadable({
        loader: () => import("../containers/addTmc"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aggregator-new/add/:corporateId",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/aggregator/index"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/pricings/ota-new/add/:corporateId",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/PricingV3"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/provider-new/add/:corporateId",
      meta: {},
      name: "Provider add",
      component: Loadable({
        loader: () => import("../containers/ondc/index"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/ondc/pricing",
    //   meta: {},
    //   name: "Ondc ",
    //   component: Loadable({
    //     loader: () => import("../containers/ondc/index"),
    //     loading: Loader,
    //   }),
    // },

    {
      exact: true,
      path: "/ondc/geofence/add/:corparateId/:id?",
      meta: {},
      name: "Ondc add",
      component: Loadable({
        loader: () => import("../containers/pricingsOndc/index"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/geofence/add/:corparateId/:id?",
      meta: {},
      name: "Geofence add",
      component: Loadable({
        loader: () => import("../containers/pricingsNew/index"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/pricings/ota/config/:corparateId/:id?",
      meta: {},
      name: "Geofence add",
      component: Loadable({
        loader: () =>
          import("../containers/PricingV3/OtaOperatingAreaConfig.jsx"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/branch-manager/add/:id",
    //   meta: {},
    //   name: "Branch manager add",
    //   component: Loadable({
    //     loader: () =>
    //       import("../containers/addCorporate/BranchManager/AddBranchManager"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/corporate",
      meta: {},
      name: "Corporates",
      component: Loadable({
        loader: () => import("../containers/corporate"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate-new",
      meta: {},
      name: "Corporates",
      component: Loadable({
        loader: () => import("../containers/users/Corporate"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/tmc",
      meta: {},
      name: "Tmc",
      component: Loadable({
        loader: () => import("../containers/users/Tmc"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/vendor",
      meta: {},
      name: "Vendor",
      component: Loadable({
        loader: () => import("../containers/users/Vendor"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/operator",
      meta: {},
      name: "Operator",
      component: Loadable({
        loader: () => import("../containers/users/OperatorNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aggregator",
      meta: {},
      name: "Aggregator",
      component: Loadable({
        loader: () => import("../containers/users/Aggregator"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/users/device",
      meta: {},
      name: "Device",
      component: Loadable({
        loader: () => import("../containers/AllDevice"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/notification",
      meta: {},
      name: "Device",
      component: Loadable({
        loader: () => import("../containers/Notifications/OperatorNotify.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/user",
      meta: {},
      name: "user",
      component: Loadable({
        loader: () => import("../containers/users/User"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/supplier",
      meta: {},
      name: "user",
      component: Loadable({
        loader: () => import("../containers/users/supplier/index.jsx"),
        loading: Loader,
      }),
    },
     {
  exact: true,
  path: "/supplier/add",
  meta: {},
  name: "supplier-add",
  component: Loadable({
    loader: () => import("../containers/users/supplier/SupplierAdd.jsx"),
    loading: Loader,
  }),
},
    {
  exact: true,
  path: "/supplier/:id",
  meta: {},
  name: "supplier-details",
  component: Loadable({
    loader: () => import("../containers/users/supplier/SupplierDetails.jsx"),
    loading: Loader,
  }),
},
    {
      exact: true,
      path: "/partners",
      meta: {},
      name: "partners",
      component: Loadable({
        loader: () => import("../containers/users/partners/index.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/partners/:id",
      meta: {},
      name: "partner-details",
      component: Loadable({
        loader: () => import("../containers/users/partners/PartnerDetails.jsx"),
        loading: Loader,
      }),
    },
{
  exact: true,
  path: "/refex-audits",
  meta: {},
  name: "refex-autits",
  component: Loadable({
    loader: () => import("../containers/tripList/RefexAudits/index.jsx"),
    loading: Loader,
  }),
},
    {
      exact: true,
      path: "/agg",
      meta: {},
      name: "Aggregator",
      component: Loadable({
        loader: () => import("../containers/users/AggregatorNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/pricings/ota",
      meta: {},
      name: "Aggregator",
      component: Loadable({
        loader: () => import("../containers/users/OtaPricingList"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/agg-new/add",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/addAggregatorNew"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/agg-new/add/:corporateId",
      meta: {},
      name: "Aggregator add",
      component: Loadable({
        loader: () => import("../containers/aggregatorNew/index.jsx"),
        loading: Loader,
      }),
    },
    // Working
    // {
    //   exact: true,
    //   path: "/ondc/pricing",
    //   meta: {},
    //   name: "Ondc",
    //   component: Loadable({
    //     loader: () => import("../containers/users/Ondc/index.jsx"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/pricing-config",
      meta: {},
      name: "Pricing config",
      component: Loadable({
        loader: () => import("../containers/pricings"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate-partner/add",
      meta: {},
      name: "Business partner add",
      component: Loadable({
        loader: () =>
          import("../containers/businessPartners/businessPartnerAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/corporate-partner/add/:bpId",
      meta: {},
      name: "Business partner add",
      component: Loadable({
        loader: () =>
          import("../containers/businessPartners/businessPartnerAdd"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      // path: "/corporate-partner",
      path: "/branch-managers",
      meta: {},
      name: "Branch managers",
      component: Loadable({
        loader: () => import("../containers/businessPartners"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/tripsheet",
      meta: {},
      name: "Trip sheet",
      component: Loadable({
        loader: () => import("../containers/tripSheet/mainSheet"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/uploadcenter",
      meta: {},
      name: "Upload Center",
      component: Loadable({
        loader: () => import("../containers/uploadCenter"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/tripsheet-ets",
      meta: {},
      name: "Trip sheet",
      component: Loadable({
        loader: () => import("../containers/TripSheetEts"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/under-construction",
      meta: {},
      name: "Under construction",
      component: Loadable({
        loader: () => import("../containers/UnderConstruction"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/track-ride/:id",
      meta: {},
      name: "Under construction",
      component: Loadable({
        loader: () => import("../containers/bookings/TrackRide"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/driver-tracking",
    //   meta: {},
    //   name: "Driver tracking",
    //   component: Loadable({
    //     loader: () => import("../containers/driverTracking/specific.jsx"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/driver-tracking/:id",
      meta: {},
      name: "Driver tracking",
      component: Loadable({
        loader: () =>
          import("../containers/driverTracking/LeafletB2bTracking.jsx"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/direction/:bookingId",
    //   meta: {},
    //   name: "Driver tracking",
    //   component: Loadable({
    //     loader: () => import("../containers/driverTracking/Direction"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/direction-tracking/:bookingId",
      meta: {},
      name: "Driver tracking",
      component: Loadable({
        loader: () => import("../containers/driverTracking/Direction"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/aari/conversation",
      meta: {},
      name: "Conversation",
      component: Loadable({
        loader: () => import("../containers/aari/AariMessages.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/aari/conversation/:conversationId/:userId",
      meta: {},
      name: "ConversationDetail",
      component: Loadable({
        loader: () => import("../containers/aari/AariConversationDetail.jsx"),
        loading: Loader,
      }),
    },
  ],
};

/**
 * Function to set route info
 * @param {routeName} routeName
 */
export const setRoutes = (routeName) => {
  routeName = routeName || "public";
  const route = ROUTE[routeName];
  return route.map((eachRoute, index) => {
    if (routeName === "private") {
      return <PrivateRoute key={index} {...eachRoute} />;
    } else {
      return <PublicRoute key={index} {...eachRoute} />;
    }
  });
};
